<div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 px-4 py-6 backdrop-blur-sm">
  <div class="w-full max-w-2xl overflow-hidden rounded-3xl border border-slate-100 bg-brand-surface-card shadow-2xl">
    <div class="flex items-start justify-between gap-6 border-b border-slate-100 p-6">
      <div>
        <p class="text-xs font-semibold uppercase tracking-[0.3em] text-brand-accent">{{ 'GUIDE_MODAL.EYEBROW' | translate }}</p>
        <h2 class="mt-2 text-2xl font-semibold text-slate-900">{{ title }}</h2>
        <p *ngIf="subtitle" class="mt-2 text-sm text-slate-500">{{ subtitle }}</p>
      </div>
      <button
        type="button"
        class="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-500 transition hover:border-slate-300 hover:text-slate-700"
        (click)="onClose()"
        aria-label="Cerrar"
      >
        <svg viewBox="0 0 24 24" class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 6l12 12M18 6l-12 12" />
        </svg>
      </button>
    </div>

    <div class="p-6">
      <div class="rounded-2xl border border-slate-100 bg-white p-5">
        <div *ngFor="let step of steps; let idx = index" class="relative flex gap-4 pb-7 last:pb-0">
          <div class="relative flex w-10 justify-center">
            <div
              class="flex h-10 w-10 items-center justify-center rounded-full border text-sm font-semibold"
              [ngClass]="{
                'border-emerald-200 bg-emerald-50 text-emerald-600': step.status === 'done',
                'border-blue-200 bg-blue-50 text-brand-accent': step.status === 'active',
                'border-slate-200 bg-white text-slate-400': step.status === 'pending'
              }"
            >
              <ng-container *ngIf="step.status === 'done'; else stepNumber">
                <svg viewBox="0 0 24 24" class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 12l4 4L19 7" />
                </svg>
              </ng-container>
              <ng-template #stepNumber>{{ idx + 1 }}</ng-template>
            </div>
            <div
              *ngIf="idx < steps.length - 1"
              class="absolute top-10 h-[calc(100%-0.25rem)] w-[2px] bg-slate-200"
              [ngClass]="{ 'bg-emerald-200': step.status === 'done' }"
            ></div>
          </div>

          <div class="flex-1 rounded-xl border border-slate-100 bg-slate-50 p-4">
            <div class="flex items-start justify-between gap-2">
              <p class="text-sm font-semibold text-slate-900">{{ step.title }}</p>
              <span
                class="rounded-full px-2.5 py-1 text-[11px] font-semibold"
                [ngClass]="{
                  'bg-emerald-50 text-emerald-600': step.status === 'done',
                  'bg-blue-50 text-brand-accent': step.status === 'active',
                  'bg-slate-100 text-slate-500': step.status === 'pending'
                }"
              >
                {{
                  step.status === 'done'
                    ? ('DOCUMENTS.STATUS_VALUES.COMPLETED' | translate)
                    : step.status === 'active'
                      ? ('COMMON.IN_PROGRESS' | translate)
                      : ('COMMON.PENDING' | translate)
                }}
              </span>
            </div>
            <p class="mt-1 text-xs text-slate-500">{{ step.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-3 border-t border-slate-100 p-6 sm:flex-row sm:justify-end">
      <button
        type="button"
        class="rounded-full border border-slate-200 px-5 py-2 text-sm font-semibold text-slate-600 transition hover:border-slate-300 hover:text-slate-800"
        (click)="onClose()"
      >
        {{ secondaryLabel }}
      </button>
      <button
        type="button"
        class="rounded-full bg-brand-accent px-5 py-2 text-sm font-semibold text-white transition hover:bg-brand-accent-hover"
        (click)="onPrimary()"
      >
        {{ primaryLabel }}
      </button>
    </div>
  </div>
</div>
